import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoMeta, getCanonicalHref } from "../config/seoMeta";
import { applySeoToDocument } from "../utils/seoDocument";

/**
 * Updates document title and core meta tags (description, Open Graph, Twitter)
 * for the current route.
 */
function PageMeta() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const { title, description, robots } = getSeoMeta(pathname);
    const canonicalHref = getCanonicalHref(pathname);
    applySeoToDocument({ title, description, robots, canonicalHref });
  }, [pathname]);

  return null;
}

export default PageMeta;
